module.exports = __webpack_public_path__ + "img/IMG_9786_L_Wood.37499d85.jpg";